import { useEffect } from 'react';

// Toggles the .win98-scope class on document.body — not a wrapper div,
// because Radix portals (Dialog, AlertDialog, Select) render into
// document.body directly, bypassing any in-tree wrapper. Shared by Layout
// (route-prefix driven) and standalone pages outside Layout (always active).
export default function useWin98Scope(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    document.body.classList.add('win98-scope');
    return () => document.body.classList.remove('win98-scope');
  }, [active]);
}
